import { useEffect, useState } from "react";
import styles from "../../../../styles/beneficios/BenefitShowQrCodeStep.module.scss";
import { QRCode } from "../../../tools/QRCode";
import { OlgaEnvironmentsAPI } from "../../../../providers/OlgaEnvironmentsAPI";
import { Button } from "../../../components/Button";
import { If } from "../../../components/control-statements";
import { SuccessIcon } from "shared/components/Icons";
import { Environment } from "shared/core/Environment";

const st = (className) => styles[className];

export const BenefitShowQrCodeStep = ({ benefit }) => {
  const [loading, setLoading] = useState(false);
  const [urlStore, setUrlStore] = useState(false);
  const [qrcode, setQRCode] = useState(false);

  const downloadQrCode = () => {
    QRCode.downloadQRCodeImage(
      `qrcode-${benefit.code}-${benefit.pin}.png`,
      urlStore
    );
  };

  const generateQrCode = async () => {
    setLoading(true);
    const { code, pin } = benefit;
    const { _data } = await OlgaEnvironmentsAPI.getConfigurations(false);
    let urlStore = `${_data?.["short-urls"].rawShortWallet}?code=${code}&pin=${pin}`;

    if (benefit.brands_valid?.length === 1) {
      urlStore = `${urlStore}&brand=${benefit.brands_valid[0]}`;
    }

    setUrlStore(urlStore);
    setQRCode(await QRCode.getDataUrl(urlStore));
    setLoading(false);
  };

  useEffect(() => {
    if (benefit?.code && benefit?.pin) {
      generateQrCode();
    }
  }, [benefit]);

  const fullCode = Environment.id === 51 ? benefit?.code : [benefit?.code, benefit?.pin].filter(Boolean).join("-");

  return (
    <div className={styles["qrcode-container"]}>
      <div className={styles.success}>
        <div className={styles.successIcon}>
          <SuccessIcon size={14} />
        </div>
      </div>
      <div className={styles.content}>
        <p>
          Você já pode divulgá-lo informando o seguinte código:
          <strong className={st("code")}>&nbsp;{fullCode}&nbsp;</strong>
          ou então utilizando o QR Code abaixo:
        </p>
        <If cond={!loading && qrcode}>
          <div className={styles.qrcode}>
            <img
              src={qrcode}
              className={`${styles["img-fluid"]} ${styles.mobile}`}
              alt="Integrações"
              id="qrcode-image"
            />
            <p className={styles.url}>{urlStore}</p>
            <Button onClick={downloadQrCode}>Salvar QR Code</Button>
            <Button className="mt-10" onClick={printQrCode}>
              Imprimir QR Code
            </Button>
          </div>
        </If>
      </div>
    </div>
  );
};

const QrIcon = () => {
  return (
    <svg
      width="28"
      height="19"
      viewBox="0 0 28 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M27.5216 0.426922C28.1595 0.999807 28.1595 1.92618 27.5216 2.44421L11.0124 18.5338C10.4808 19.1554 9.53032 19.1554 8.94249 18.5338L0.439558 10.2452C-0.146519 9.72717 -0.146519 8.80081 0.439558 8.22792C1.02557 7.66113 1.9761 7.66113 2.56205 8.22792L10.0056 15.4865L25.4517 0.426922C26.0395 -0.142307 26.9901 -0.142307 27.5216 0.426922Z"
        fill="#82D997"
      />
    </svg>
  );
};

const printQrCode = () => {
  const iframe = document.createElement("iframe");
  // Make it hidden
  iframe.style.height = 0;
  iframe.style.visibility = "hidden";
  iframe.style.width = 0;

  // Set the iframe's source
  iframe.setAttribute("srcdoc", "<html><body></body></html>");

  document.body.appendChild(iframe);

  iframe.addEventListener("load", function () {
    // Clone the image
    const image = document.getElementById("qrcode-image").cloneNode();
    image.style.maxWidth = "100%";

    // Append the image to the iframe's body
    const body = iframe.contentDocument.body;
    body.style.textAlign = "center";
    body.appendChild(image);

    image.addEventListener("load", function () {
      // Invoke the print when the image is ready
      iframe.contentWindow.print();
    });
  });
};
